import React from "react";

import { Link } from "react-router";

import { Subscribe } from "unstated";

import { ProfileContainer } from "./containers/profile-container";

import { Form, Field } from "react-final-form";

import { FORM_ERROR } from "final-form";

import { withRouter } from "react-router";

import { TextInput } from "../components/ui/text-input";
import { FormErrors } from "../components/ui/form-errors";

import {
  required,
  email,
  maxLength,
  composeField
} from "../lib/form-validators";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PublicPage from "./public-page";

import navigation from "../lib/navigation-utilities";

const ForgotPassword = () => {
  const onSubmit = (profileContainer) => async (values) =>
    profileContainer
      .resetPassword(values.email)
      .then(() => navigation.replace("/password_reset"))
      .catch(() => {
        return {
          [FORM_ERROR]:
            "We couldn't locate that address. Please check your spelling."
        };
      });

  return (
    <Subscribe to={[ProfileContainer]}>
      {(profileContainer) => (
        <PublicPage>
          <div className="content text-center align-items-center">
            <h3>Forgot Password?</h3>
            <p>Enter your email so we can reset it.</p>
            <Form
              onSubmit={onSubmit(profileContainer)}
              render={({
                handleSubmit,
                submitting,
                submitError,
                dirtySinceLastSubmit
              }) => (
                <form onSubmit={handleSubmit}>
                  <Field
                    name="email"
                    inputClass="dc-login_input"
                    validate={composeField(required, email, maxLength(256))}
                    render={TextInput}
                    placeholder="EMAIL ADDRESS"
                    prependValue={
                      <div className="dc-login_icon">
                        <FontAwesomeIcon
                          icon={["fas", "envelope"]}
                          size="sm"
                          color="#69717a"
                        />
                      </div>
                    }
                  />

                  <FormErrors
                    submitError={submitError}
                    dirtySinceLastSubmit={dirtySinceLastSubmit}
                  />

                  <hr className="mh-3 w-100" />
                  <div className="mt-3 w-100">
                    <button
                      type="submit"
                      className="btn btn-primary btn-xl w-100 text-uppercase"
                      disabled={submitting}>
                      SEND
                    </button>
                  </div>
                </form>
              )}
            />
          </div>
          <div className="footer text-center mt-5">
            <Link className="text-uppercase" to="/">
              Login
            </Link>
          </div>
        </PublicPage>
      )}
    </Subscribe>
  );
};

export default withRouter(ForgotPassword);
